<template>
  <layout-editor-page
    class="repair-td-page"
    :title="formTitle"
    :error="error"
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="isAvailableToSave"
    :isCancel="!isAvailableToSave"
    @command="setCommand"
  >
    <template v-slot:tools>
      <user-actions
        :rfq3ID="rfq3ID"
        @onDisplayCustomer="handlerDisplayCustomer"
        @onDisplayWO="handlerDisplayWO"
        @onUpdatePriceWO="handlerUpdatePriceWO"
        @onUpdatePricePO="handlerUpdatePricePO"
        @onEmailTD="handlerEmailTD"
        @onEmailTDReport="handlerEmailTDReport"
        @onDownloadTDReport="handlerDownloadTDReport"
      ></user-actions>
    </template>
    <div class="row mt-4">
      <div class="col-xl-6 col-12">
        <section-repair-report
          :data="dataRepairReport"
          :model="ModelRepairReport"
          @onAutoSave="handleAutoSaveRepairReport"
        >
        </section-repair-report>
      </div>
      <div class="col-xl-6 col-12">
        <div class="repair-td-page__right-sections">
          <div class="repair-td-page__right-section">
            <section-special-instruction :instructions="specialInstruction" />
          </div>
          <div class="repair-td-page__right-section">
            <section-replacement
              :data="dataRFQ3"
            ></section-replacement>
          </div>
        </div>
      </div>
    </div>

    <dialog-status-repair-order />
    <dialog-new-instruction-repair-order />
    <dialog-status-customer />
    <dialog-new-instruction-customer />
    <dialog-connect-customer
      ref="dialog-connect-customer"
      filterFieldName="po"
      :filterValueTemplate="filterTemplateConnectCustomer"
    />
    <dialog-connect-wo
      ref="dialog-connect-wo"
      filterFieldName="po"
      :filterValueTemplate="filterTemplateConnectWO"
    ></dialog-connect-wo>
    <dialog-send-td-email
      :id="dataRFQ3.id"
      ref="dialog-send-td-email"
    />
  </layout-editor-page>
</template>

<script>
import { AutoSaveMixin } from '@/mixins/FormAutoSave'
import { routeEditLogic } from '@/mixins/modals'
import { MainModel } from '@/models/RFQ3'
import { ServiceRepairTearDowns } from '@/services/RepairTearDowns'
import { ServicePdf } from '@/services/pdf-generators'
import { api } from '@/services/api'
import { toDate } from '@/utils/filters'
import { downloadBase64 } from '@/utils/files'
import { ServiceRFQ2s } from '@/services/RFQ2s'
import * as dynamic from '@/utils/dynamic'
import { ServiceRFQ3s } from '@/services/RFQ3s'

const REMARK_SUBJECT_ID = 35

export default {
  name: 'EditorRepairExchangeTd',
  mixins: [AutoSaveMixin, routeEditLogic],
  components: {
    'section-repair-report': () => import(/* webpackChunkName: 'RFQRepairTd' */ './SectionRepairReport/Index'),
    'section-replacement': () => import(/* webpackChunkName: 'RFQRepairTd' */ './SectionReplacement/Index'),
    'section-special-instruction': () => import(/* webpackChunkName: 'RFQRepairTd' */ './SectionSpecialInstruction'),
    'user-actions': () => import(/* webpackChunkName: 'RFQRepairTd' */ './UserActions'),
    'dialog-connect-wo': () => import(/* webpackChunkName: 'DialogConnectWo' */ '@/components/Shared/ActivityDialogConnectToOpenWO/Index'),
    'dialog-connect-customer': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ActivityConnectToCustomerPoFollowUp/Index'),
    'dialog-status-repair-order': () => import(/* webpackChunkName: 'DialogStatusRepairOrder' */ '@/components/Shared/ActivityDialogStatusEmailRepairOrder'),
    'dialog-new-instruction-repair-order': () => import(/* webpackChunkName: 'DialogNewInstructionRepairOrder' */ '@/components/Shared/ActivityDialogNewInstructionRepairOrder'),
    'dialog-new-instruction-customer': () => import(/* webpackChunkName: 'DialogNewInstructionCustomer' */ '@/components/Shared/ActivityDialogNewInstructionCustomer'),
    'dialog-status-customer': () => import(/* webpackChunkName: 'ActivityDialogStatusEmailCustomer' */ '@/components/Shared/ActivityDialogStatusEmailCustomer'),
    'dialog-send-td-email': () => import(/* webpackChunkName: 'RFQRepairTd' */ './DialogSendTDEmail')
  },
  props: {
    config: { type: Object, required: true }
  },
  data () {
    return {
      isNew: true,
      isVisible: false,
      isLoading: false,
      rfq3ID: null,
      error: null,
      dataRFQ3: {},
      dataRepairReport: {},
      specialInstruction: []
    }
  },
  computed: {
    formTitle () {
      const { customerCompanyName = '', rfqTypeTitle = '', po = '' } = this.dataRFQ3
      const { partSN = '', partID } = this.dataRepairReport
      const partNumberData = this.dataSourcePartNumber.map[partID]
      const partNumber = (partNumberData && partNumberData.partNumber) || ''
      return `${customerCompanyName} (${rfqTypeTitle}) - po ${po} for ${partNumber}, part-sn: ${partSN}`
    },
    isAvailableToSave () {
      return !this.isNew
    },
    filterTemplateConnectWO () {
      return (filterValue) => {
        return `rfq.po == "${filterValue}"`
      }
    },
    filterTemplateConnectCustomer () {
      return (filterValue) => {
        return `po == "${filterValue}"`
      }
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    dataSourcePartNumber () {
      let partID = this.dataRepairReport.partID
      if (partID) {
        return this.API(`Parts/GetAllDynamic?select=id,partNumber&filter=id==${partID}&take=1`)
      } else {
        return {
          map: {},
          records: []
        }
      }
    }
  },
  methods: {
    ModelRFQ3 () {
      return new MainModel()
    },
    ModelRepairReport () {
      return {
        id: null,
        entryDate: null,
        partID: null,
        rfqid: '',
        partSN: '',
        typeOfOperationID: null,
        baxReceiveDate: null,
        leadTime: null,
        inspectionFee: null,
        rsFinding: null,
        rsCurrencyID: null,
        baxCurrencyID: null,
        baxLaborCost: null,
        baxTotalCost: null,
        baxPartsCost: null,
        remarks: '',
        customerApprovalDate: null,
        rsLaborCost: null,
        rsPartsCost: null,
        rsTotalCost: null
      }
    },
    handlerDisplayCustomer () {
      this.$refs['dialog-connect-customer'].show({ po: this.dataRFQ3.po })
    },
    handlerDisplayWO () {
      this.$refs['dialog-connect-wo'].show({ po: this.dataRFQ3.po })
    },
    handlerUpdatePriceWO () {
      this.isLoading = true
      return this._processUpdateRFQ2()
        .then(() => {
          this.requestSuccessHandler()
          this.loadData()
        })
        .catch((err) => {
          this.requestErrorHandler(err)
          this.isLoading = false
        })
    },
    handlerUpdatePricePO () {
      this.isLoading = true
      return this._processUpdateRFQ3()
        .then(() => {
          this.requestSuccessHandler()
          this.loadData()
        })
        .catch((err) => {
          this.requestErrorHandler(err)
          this.isLoading = false
        })
    },
    _processUpdateRFQ2 () {
      const { rfqid, partID, partSN, leadTime, rsCurrencyID, rsTotalCost } = this.dataRepairReport
      const params = dynamic.createParams({
        select: 'id',
        filter: dynamic.mergeFilters(
          dynamic.equals('rfqid', rfqid),
          dynamic.equals('partID', partID),
          dynamic.equals('partSN', partSN)
        ).join('&&')
      })

      const updateRFQ2 = ({ id }) => {
        const data = {
          id,
          price: rsTotalCost,
          currencyID: rsCurrencyID,
          estimatedDeliveryDate: leadTime
        }
        return ServiceRFQ2s.patch(data)
      }

      return ServiceRFQ2s.getAllDynamic(params).then(({ data }) => {
        return Promise.all(
          data.value.map(updateRFQ2)
        )
      })
    },
    _processUpdateRFQ3 () {
      const { rfqid, partID, partSN, baxCurrencyID, baxTotalCost } = this.dataRepairReport
      const params = dynamic.createParams({
        select: 'id',
        filter: dynamic.mergeFilters(
          dynamic.equals('rfqid', rfqid),
          dynamic.equals('partID', partID),
          dynamic.equals('partSN', partSN)
        ).join('&&')
      })

      const updateRFQ3 = ({ id }) => {
        const data = {
          id,
          price: baxTotalCost,
          currencyID: baxCurrencyID,
          conditionID: 44
        }
        return ServiceRFQ3s.patch(data)
      }

      return ServiceRFQ3s.getAllDynamic(params)
        .then(({ data }) => {
          return Promise.all(
            data.value.map(updateRFQ3)
          )
        })
    },
    handlerEmailTD (logoType) {
      const { customerContactEmail, po, entryDate } = this.dataRFQ3
      const { baxLaborCost, baxPartsCost, baxTotalCost, baxCurrencyID, partSN } = this.dataRepairReport
      const emailToList = []
      customerContactEmail && emailToList.push(customerContactEmail)
      const data = {
        emailToList,
        subject: `${this.L10n('teardown-report-from-bax-po')}: ${po}`
      }
      const { partID, inspectionFee, remarks } = this.dataRepairReport
      const partNumberData = this.dataSourcePartNumber.map[partID]
      const partNumber = (partNumberData && partNumberData.partNumber) || ''
      const currency = this.dataSourceCurrency.map[baxCurrencyID] && this.dataSourceCurrency.map[baxCurrencyID].title
      // MAP FOR BODY
      const contentData = {
        PO: po,
        partNumber,
        partSN,
        baxLaborCost,
        baxPartsCost,
        baxTotalCost,
        currency,
        price: baxTotalCost,
        date: this.$moment(entryDate).add(7, 'day').format('DD/MM/YYYY'),
        remark: remarks,
        remarks,
        inspectionFee
      }
      // END MAP
      const _data = {
        contentKey: 'td-report-email',
        contentData,
        data,
        logoType,
        sendPDF: false
      }
      this.$refs['dialog-send-td-email'].show(_data)
    },
    handlerEmailTDReport (logoType) {
      const { customerContactName, customerContactEmail, po } = this.dataRFQ3
      const emailToList = []
      customerContactEmail && emailToList.push(customerContactEmail)
      const data = {
        emailToList,
        subject: `${this.L10n('repair-quote-for-po')}: ${po}`
      }
      // MAP FOR BODY
      const contentData = {
        PO: po,
        customerName: customerContactName,
        CustomerName: customerContactName
      }
      // END MAP
      const _data = {
        contentKey: 'repair-quote-email',
        contentData,
        data,
        logoType,
        sendPDF: true
      }
      this.$refs['dialog-send-td-email'].show(_data)
    },
    async handlerDownloadTDReport (logoKey) {
      this.isLoading = true
      const { po } = this.dataRFQ3

      try {
        const { data: pdfBase64 } = await ServicePdf.generateTd({ id: this.rfq3ID, logoKey, translate: this.L10n })
        const fileName = encodeURIComponent(`td_${po}_${toDate(new Date(), 'YYYY-MM-DD')}`)
        await downloadBase64(pdfBase64, fileName)
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    },
    setCommand (command) {
      if (command === 'cancel') {
        this.isVisible = false
        this.mixSetRoute()
      }
      if (command === 'back') {
        this.isVisible = false
        this.mixSetRoute()
        this.$bus.$emit('Refresh-Grid', { id: this.config.id })
      }
    },
    loadData () {
      this.isLoading = true
      return this._loadDataRFQ3()
        .then(() => {
          return Promise.all([this._loadDataRepairTearDowns(), this._loadSpecialInstruction()])
        })
        .catch((err) => {
          this.error = err
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    _loadDataRFQ3 () {
      let selected = Object.keys(this.ModelRFQ3())
      let params = dynamic.createParams({
        select: [
          'rfq.po as po', 'rfq.customerContact.email as customerContactEmail', 'rfq.customerContact.name as customerContactName',
          'rfq.entryDate as entryDate', 'rfq.rfqType.title as rfqTypeTitle', 'rfq.customerCompany.name as customerCompanyName',
          'rfq.customerCompanyID'
        ].concat(selected).join(','),
        filter: `id == ${this.rfq3ID}`
      })
      return api
        .get(`RFQ3s/GetAllDynamic`, { params })
        .then(({ data }) => {
          if (data.value[0]) {
            this.dataRFQ3 = data.value[0]
          } else {
            throw new Error('The record not founded')
          }
        })
    },
    _loadDataRepairTearDowns () {
      const { rfqid, partSN, partID } = this.dataRFQ3
      let params = dynamic.createParams({
        filter: [`rfqid == "${rfqid}"`, `partSN == "${partSN}"`, `partID == ${partID}`].join(' && ')
      })
      return ServiceRepairTearDowns
        .getAllDynamic(params)
        .then(({ data }) => {
          if (data.value.length === 0) {
            throw new Error(this.L10n('has-no-td'))
          } else {
            this.dataRepairReport = data.value[0] || {}
          }
        })
    },
    _loadSpecialInstruction () {
      const { customerCompanyID } = this.dataRFQ3
      if (!customerCompanyID) {
        return Promise
          .resolve()
          .then(() => {
            this.specialInstruction = []
          })
      }
      let params = dynamic.createParams({
        filter: `remarkSubjectID == ${REMARK_SUBJECT_ID} && companyID == ${customerCompanyID}`
      })
      return api
        .get(`CompanyRemarks/GetAllDynamic`, { params })
        .then(({ data }) => {
          this.specialInstruction = data.value
        })
    },
    handleAutoSaveRepairReport (data) {
      this.mixAutoSave({ ...data, api: `RepairTearDowns/Patch/${this.dataRepairReport.id}`, settings: { key: 'REPAIR_REPORT' } })
    },
    // MIXINS AUTOSAVE
    mixSuccessAutoSave (data, settings) {
      switch (settings.key) {
        case 'REPAIR_REPORT':
          this.dataRepairReport = Object.assign({}, this.dataRepairReport, data)
          break
        default:
          console.error('REPAIR TD Success => autoSave :', settings.key)
      }
    },
    mixErrorAutoSave (data, settings) {
      switch (settings.key) {
        case 'REPAIR_REPORT':
          this.dataRepairReport = Object.assign({}, this.dataRepairReport)
          break
        default:
          console.error('REPAIR TD Error => autoSave :', settings.key)
      }
    },
    // MIXINS
    mixHookState ({ value, state }) {
      if (state === 'edit') {
        this.rfq3ID = value
        this.isNew = false
        this.isVisible = true
        this.loadData()
      }
    },
    mixHookNew () {
      this.isNew = true
      this.isVisible = true
    },
    mixHookReset () {
      this.isNew = true
      this.rfq3ID = null
      this.dataRFQ3 = {}
      this.dataRepairReport = {}
      this.error = null
    }
  }
}
</script>
<style lang="stylus">
  .repair-td-page{
    &__right-sections{
      height 100%
      display flex
      flex-direction column
    }
    &__right-section:last-of-type{
      flex 1
    }
  }
</style>
